"use client";

// import ReactPlayer from 'react-player';
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Card, CardContent } from "@/components/ui/card";
function VideoBlockConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <Card className="w-full max-w-4xl mx-auto">
        <CardContent className="p-0">
          <div className="w-full aspect-video bg-muted/30 animate-pulse rounded-t-xl" />
          <div className="p-6 space-y-3">
            <div className="h-6 bg-muted/30 animate-pulse rounded w-3/4" />
            <div className="h-4 bg-muted/30 animate-pulse rounded w-full" />
            <div className="h-4 bg-muted/30 animate-pulse rounded w-5/6" />
          </div>
        </CardContent>
      </Card>;
  }
  if (error) {
    return <Card className="w-full max-w-4xl mx-auto">
        <CardContent className="p-6 bg-primary-dark">
          <p className="text-sm text-foreground-primary">Failed to load video content.</p>
        </CardContent>
      </Card>;
  }
  if (posts.length === 0) {
    return <Card className="w-full max-w-4xl mx-auto">
        <CardContent className="p-6 bg-primary-dark">
          <p className="text-foreground-primary">No video available.</p>
        </CardContent>
      </Card>;
  }
  const video = posts[0];
  const videoUrl = video.customFields?.url || "https://youtu.be/y7IUPV6YkRk";
  const videoTitle = video.customFields?.title || video.title || "New Mavericks Highest Level of CEO Development & Performance";
  const videoDescription = video.customFields?.description || video.excerpt || "New Mavericks offers the highest level of CEO development which enables CEOs to lead from their most enlightened state of having more of the right thoughts at the right time to make the right decision. This enables them to create, protect and build business while being in robust perfect health.";
  return <Card className="w-full max-w-4xl mx-auto">
      <CardContent className="p-0">
        <div className="w-full aspect-video rounded-t-xl overflow-hidden bg-black">
          <ReactPlayer url={videoUrl} width="100%" height="100%" controls light playsinline />
        </div>
        <div className="p-6 space-y-4 bg-primary-dark">
          <h2 className="text-2xl font-semibold text-foreground-primary">{videoTitle}</h2>
          <p className="text-base text-foreground-primary leading-relaxed whitespace-pre-wrap">
            {videoDescription}
          </p>
        </div>
      </CardContent>
    </Card>;
}
export default function VideoBlock() {
  return;
}